
import Vue from 'vue'
import type { PropType } from 'vue'

interface LinkItem {
  title: string,
  code: string,
  children: LinkItem[]
}

export default Vue.extend({
  name: 'FooterSubMenu',
  props: {
    menuItems: {
      type: Array as PropType<LinkItem[]>,
      required: true,
      default: () => { }
    },
    parentCode: {
      type: String,
      required: false,
      default: ''
    },
    parentVisibility: {
      type: Boolean,
      required: false,
      default: false
    },
    activeList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTabsList: []
    }
  },
  computed: {
    filteredMenuItems () {
      return this.menuItems?.filter((item: { showInFooter }) => item?.showInFooter ?? false)
    }
  },
  watch: {
    parentVisibility (newValue: boolean) {
      if (newValue) { return }
      this.$set(this, 'activeTabsList', this.activeTabsList?.map(_tab => false))
    }
  },
  created () {
    this.activeTabsList = this.filteredMenuItems?.map(item => item?.showByDefault ?? false)
  },
  methods: {
    changeMenuVisibility (index: number) {
      this.$set(this.activeTabsList, index, !this.activeTabsList[index])
    },
    filterItems (items: any[]) {
      return items?.filter((item: { showInFooter }) => item?.showInFooter ?? false) || []
    }
  }
})
